/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import validate from './validation'
import {
  signInSchema,
  signInSchemaV2,
  shipmentSchemaBeta,
  shipmentSchemaBetaV2,
  customerSchemaBeta,
  shippingSavedAddressSchemaBeta,
  billingSavedAddressSchemaBeta,
} from './schemas'

const addFocusToTheField = (data = {}) => {
  const [nodeKey] = Object.keys(data)
  const domNodeToFocus = document.getElementById(nodeKey)
  if (domNodeToFocus) {
    domNodeToFocus.scrollIntoView({ behavior: 'smooth' })
    // domNodeToFocus.focus();
  }
}

export const validateForm = (
  customer,
  shipment,
  customerDetails,
  shipmentDetails,
  hasSameBillingAddress,
  getShippingAddress,
  updateCheckoutContextAll,
  checkoutContext,
  extraContextUpdate = {},
) => {
  const customerInstance = hasSameBillingAddress
    ? getShippingAddress(customer, shipment, hasSameBillingAddress)
    : customer

  const validateShipmentSavedAddress = shipmentDetails.isSavedAddress
    && validate(shipment, shippingSavedAddressSchemaBeta)

  const validateBillingSavedAddress = shipmentDetails.isSavedAddress
    && !hasSameBillingAddress
    && validate(customer, billingSavedAddressSchemaBeta)

  const validateShipment = shipmentDetails.isNewAddress && validate(shipment, shipmentSchemaBetaV2)

  const validateCustomer = (hasSameBillingAddress
    ? shipmentDetails.isNewAddress
    : customerDetails.isNewAddress)
    && validate(customerInstance, customerSchemaBeta)

  if (
    validateCustomer
    || validateShipment
    || validateShipmentSavedAddress
    || validateBillingSavedAddress
  ) {
    updateCheckoutContextAll({
      ...checkoutContext,
      customer: customerInstance,
      shipment,
      errors: {
        customer: hasSameBillingAddress
          ? false
          : shipmentDetails.isSavedAddress
            ? validateBillingSavedAddress
            : validateCustomer,
        delivery: validateShipment || validateShipmentSavedAddress,
      },
      ...extraContextUpdate,
    })

    if (validateShipmentSavedAddress || validateBillingSavedAddress) {
      addFocusToTheField({ shippingSavedAddress: '' })
    }

    if (validateShipment) {
      addFocusToTheField(validateShipment || validateCustomer)
    }
    return false
  }
  updateCheckoutContextAll({
    ...checkoutContext,
    customer: customerInstance,
    shipment,
    errors: { customer: false, delivery: false },
    ...extraContextUpdate,
  })
  return true
}
export const signInValidation = (data, resetFlag = false) => {
  const schema = { ...signInSchema }
  // delete schema.captcha
  if (resetFlag) delete schema.loginPassword
  return validate(data, schema)
}

export const signInValidationV2 = (data, resetFlag = false) => {
  const schema = { ...signInSchemaV2 }
  // delete schema.captcha
  if (resetFlag) delete schema.loginPassword
  return validate(data, schema)
}

export const validateCustomer = (data, prefixKey) => validate(
  data,
  prefixKey === 'customer' ? customerSchemaBeta : shipmentSchemaBeta,
)

export const getError = (nameProp, valueProps) => {
  if (nameProp.includes('login')) return ''
  const formSchema = nameProp.includes('delivery')
    ? shipmentSchemaBeta
    : customerSchemaBeta
  const schemaKey = formSchema[nameProp]
  if (schemaKey && !schemaKey.compare) {
    const schema = { [nameProp]: schemaKey }
    const data = { [nameProp]: valueProps }
    const hasError = validate(data, schema)
    return hasError && hasError[nameProp]
  }
  return ''
}

export const outsideClickHandler = (enable, parentIds, cb) => {
  const clickBody = event => {
    const hasChildNode = parentIds.find(parentId => {
      const parentNode = document.getElementById(parentId)
      return parentNode && parentNode.contains(event.target)
    })
    if (hasChildNode) return ''
    document.body.removeEventListener('click', clickBody)
    document.body.removeEventListener('touchstart', clickBody)
    return cb(event)
  }
  return enable
    ? (document.body.removeEventListener('click', clickBody),
    document.body.removeEventListener('touchstart', clickBody))
    : (document.body.addEventListener('click', clickBody),
    document.body.addEventListener('touchstart', clickBody))
}

export const getNumberMasked = (phone = '') => {
  if (phone.length !== 10) return phone
  return `(${phone.substring(0, 3)}) ${phone.substring(
    3,
    6,
  )} - ${phone.substring(6, 10)}`
}

export const emptyFields = (prefix, address) => {
  const fieldsEmpty = [
    'FirstName',
    'LastName',
    'Name',
    'StreetAddress',
    'SuburbAddress',
    'City',
    'State',
    'Postcode',
    ...prefix === 'customer'
      ? []
      : ['Telephone', 'EmailAddress'],
  ]
  const newObj = Object.entries(address).reduce((prev, [key, value]) => {
    if (fieldsEmpty.includes(key.replace(prefix, ''))) {
      return { ...prev, [`${key}`]: '' }
    }
    return { ...prev, [`${key}`]: value }
  }, {})
  newObj[`${prefix}Postcode`] = '61301'
  newObj[`${prefix}State`] = 'IL'
  newObj[`${prefix}City`] = 'La Salle'
  newObj[`${prefix}Country`] = 'US'
  return newObj
}

export const generalValidate = validate
